import React, { useState, useEffect } from "react";
import { IonLabel } from "@ionic/react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

const PieCharts: React.FC = () => {
    const [data, setData] = useState<any>(null);
    const [question, setQuestion] = useState<string>("");
    const [correctAnswer, setCorrectAnswer] = useState<string>("");
    const [answer, setAnswer] = useState<string>("");
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    const generatePieChartData = () => {
        const categories = ["Apples", "Bananas", "Grapes", "Oranges", "Mangoes"];
        const shuffledNames = [...categories].sort(() => Math.random() - 0.5);
        const values = Array.from({ length: 4 }, () => Math.floor(Math.random() * 80) + 20);
        const total = values.reduce((sum, val) => sum + val, 0);

        return {
            labels: shuffledNames.slice(0, 4),
            datasets: [
                {
                    label: "Fruits Sold",
                    data: values,
                    backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
                    borderWidth: 1,
                },
            ],
            rawData: shuffledNames.slice(0, 4).map((category, index) => ({ category, value: values[index] })),
            total,
        };
    };

    const generateQuestionAndAnswer = (rawData: any[]) => {
        const total = rawData.reduce((sum, entry) => sum + entry.value, 0);
        const largest = rawData.reduce((max, entry) => (entry.value > max.value ? entry : max), rawData[0]);

        const questionOptions = [
            { question: `How many ${largest.category.toLowerCase()} were sold?`, answer: largest.value.toString() },
            { question: `Which fruit has the most sales?`, answer: largest.category },
            { question: `How many fruits were sold in total?`, answer: total.toString() },
        ];

        const randomIndex = Math.floor(Math.random() * questionOptions.length);
        return questionOptions[randomIndex];
    };

    const handleSubmitAnswer = () => {
        if (answer && answer === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                handleNewQuestion();
                setShowImage(false);
                setAnswer("");
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    const handleNewQuestion = () => {
        const chartData = generatePieChartData();
        const { question, answer } = generateQuestionAndAnswer(chartData.rawData);

        setData(chartData);
        setQuestion(question);
        setCorrectAnswer(answer);
    };

    useEffect(() => {
        handleNewQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Data Handling - Pie Charts"; // Set page title
    }, []);

    const chartOptions = {
        plugins: {
            datalabels: {
                color: '#fff',
                font: {
                    size: 16,
                    weight: 'bold',
                },
                formatter: (value: number) => `${value}`,
            },
            legend: {
                labels: {
                    font: {
                        size: 14,
                    },
                },
            },
            tooltip: {
                bodyFont: {
                    size: 14,
                },
            },
        },
    };

    return (
        <>
            {showImage === false ? (
                <div className="contentPart showCenter additionWord">
                    <div className="pieChartDiv">
                        {data && (
                            <>
                                <div className="pieChart">
                                    <Pie options={chartOptions as any} data={data} height={300} width={300} style={{ height: "300px", width: "300px" }} />
                                </div>
                                <div className="pieChartQuestionPart mt-2">
                                    <h3>{question}</h3>
                                    <div className="mb-4">
                                        <IonLabel position="floating">Your Answer</IonLabel>
                                        <input
                                            type="text"
                                            value={answer}
                                            onChange={(e) => setAnswer(e.target.value)}
                                            style={{ width: "100%" }}
                                            className={`form-control blank-input ${error ? 'error' : ''}`}
                                        />
                                    </div>
                                    <div className="half-width">
                                        <div className="text-center">
                                            <div className="optionButton" onClick={handleSubmitAnswer}>
                                                Submit
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: '150px' }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default PieCharts;
